import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './components/Home/Home';
import WalletSearch from './components/WalletSearch';
import PoolsList from './components/PoolsList'; 
import Pool from './components/Pool';
import Coins from './components/Coins';
import Blocks from './components/Blocks';
import Miners from './components/Miners';
import Exchanges from './components/Exchanges';
import AlgorithmHardware from './components/AlgorithmHardware';
import AlgorithmList from './components/AlgorithmList/AlgorithmList';

import Register from './components/Register';
import Login from './components/Login';
import Logout from './components/Logout';
import PrivateRoute from './ProtectedRoute';
import Payment from './components/Payment';
import UserProfile from './components/UserProfile';
import AdvertisingGuide from './components/AdvertisingGuide';
import About from './components/About';
import Terms from './components/Terms';
import Privacy from './components/Privacy';
import { Box } from '@mui/material';

const CurrencyEvents = lazy(() => import('./components/CurrencyEvents'));
const NewCoins = lazy(() => import('./components/NewCoins/NewCoins'));
const LatestReleases = lazy(() => import('./components/LatestReleases'));
const Dashboard = lazy(() => import('./components/Dashboard'));

const NotFound = () => (
  <div>
    <h1>404 - Not Found</h1>
    <p>The page you are looking for does not exist.</p>
  </div>
);

function App() {
  return (
    <Router>
      <Box 
        sx={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
        }}
      >
        <Navbar />
        <Box 
          component="main" 
          sx={{ 
            flexGrow: 1, 
            padding: '20px',
            marginBottom: '80px',
          }} 
        >
          <Suspense fallback={<div>Loading...</div>}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/coin/:symbol" element={<Home />} />
              <Route path="/walletsearch/:address?" element={<WalletSearch />} />
              <Route path="/pools" element={<PoolsList />} /> 
              <Route path="/pool/:pool_name" element={<Pool />} />
              <Route path="/coins" element={<Coins />} />
              <Route path="/newcoins" element={<NewCoins />} />
              <Route path="/latestreleases" element={<LatestReleases />} />
              <Route path="/blocks" element={<Blocks />} />
              <Route path="/miners" element={<Miners />} />
              <Route path="/exchanges" element={<Exchanges />} />
              <Route path="/currencyevents" element={<CurrencyEvents />} />
              <Route path="/algorithmhardware/:algo?" element={<AlgorithmHardware />} />
<Route path="/algorithmlist" element={<AlgorithmList />} />
              <Route path="/advertisingguide" element={<AdvertisingGuide />} />
              <Route path="/About" element={<About />} />
              <Route path="/Terms" element={<Terms />} />
              <Route path="/Privacy" element={<Privacy />} />

              {/* pago */}
              <Route path="/payment" element={<Payment userId={1} serviceCost={10} />} /> 
              <Route path="/user/profile" element={<UserProfile userId={1} />} />
              {/* privadas */}
              <Route 
                path="/dashboard" 
                element={
                  <PrivateRoute>
                    <Dashboard />
                  </PrivateRoute>
                } 
              />

              {/* autenticación */}
              <Route path="/register" element={<Register />} />
              <Route path="/login" element={<Login />} />
              <Route path="/logout" element={<Logout />} />

              {/* Página 404 */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </Box>
        <Footer />
      </Box>
    </Router>
  );
}

export default App;
